<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Holidays</h1>
      <div class="text-large">There is a holiday for everything, I swear.</div>
    </div>
  </div>
<Posts Category="holiday" ShowTitle="true" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
